<p-button [label]="titleDownloadFile" icon="fa-solid fa-file-excel" styleClass="p-button-link" [disabled]="isConfirmed"
    (onClick)="download()"></p-button>
<div class="field col-12 md:col-12">
    <p-fileUpload id="delivery-way-restrict" #inputFile name="deliveryWayRestrict[]" mode="basic"
        chooseLabel="Enviar planilha com as informações atualizadas" accept=".xlsx" [disabled]="isConfirmed"
        [customUpload]="true" (uploadHandler)="onImportFile($event)" [auto]="true" [disabled]="isLoading || isConfirmed"
        chooseIcon="fa-solid fa-upload"></p-fileUpload>
    <div class="mt-1">
        <small><strong>Somente aceita o arquivo no formato Excel (.xlsx)</strong> e o arquivo deve ser
            baseado no modelo acimax.</small>
    </div>
</div>